import { subscriptionExchange } from '@urql/core';
import { createClient } from 'graphql-ws';

import { refetchToken } from '@shared/auth/auth';
import { tokenStore, isTokenValid } from '@shared/auth/token.store';

// Тот же origin, что и у страницы: подписки идут через nginx-прокси /graphql,
// как и обычные запросы. Схему берём у страницы — на https нужен wss://, иначе
// CSP (connect-src 'self' wss://$host …) режет соединение. Прежний фолбэк
// 'ws://localhost:4000' уезжал в прод как есть: VITE_WS_BASE_URL не задан ни в
// Dockerfile, ни в CI, ни в task definition.
const wsBaseUrl =
  import.meta.env.VITE_WS_BASE_URL ??
  `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}`;

const wsClient = createClient({
  url: `${wsBaseUrl}/graphql`,
  connectionParams: async () => {
    if (!isTokenValid()) {
      await refetchToken().catch(() => {});
    }
    const token = tokenStore.getState().accessToken?.token;
    return { authorization: token ? `Bearer ${token}` : '' };
  },
  shouldRetry: () => true,
  retryAttempts: 10,
  retryWait: (retries) =>
    new Promise((resolve) => setTimeout(resolve, Math.min(1000 * 2 ** retries, 10000))),
  keepAlive: 25000,
});

tokenStore.getState().registerWsDisposer(() => {
  void wsClient.dispose();
});

export const ws = subscriptionExchange({
  forwardSubscription(request) {
    return {
      subscribe(sink) {
        const unsubscribe = wsClient.subscribe(
          {
            query: request.query ?? '',
            variables: request.variables as Record<string, unknown>,
            operationName: request.operationName ?? undefined,
            extensions: request.extensions as Record<string, unknown>,
          },
          sink,
        );
        return { unsubscribe };
      },
    };
  },
});
